import type Highcharts from 'highcharts';

import {formatDate, UNITS} from 'common/util/date';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';

export function defaultXAxisLabelFormatter(value: number | Date, unit: TimeUnit): string {
  return formatDate(value, {
    unit,
    displayRangeIfWeek: false,
    customFormatting: {
      [UNITS.minute]: `h:mma`,
      [UNITS.hour]: `MMM D, ha`,
      [UNITS.day]: `MMM D`,
      [UNITS.week]: `MMM D`,
      [UNITS.month]: `MMMM`,
      [UNITS.quarter]: `[Q]Q YYYY`,
      [UNITS.year]: `YYYY`,
    },
  });
}

export function getHighchartsColorString(color: Highcharts.ColorType): string {
  return typeof color === `string` ? color : (color as Highcharts.PatternObject)?.pattern?.color;
}
